import { render, staticRenderFns } from "./order-history.vue?vue&type=template&id=3cb5ed11&scoped=true&"
import script from "./order-history.vue?vue&type=script&lang=js&"
export * from "./order-history.vue?vue&type=script&lang=js&"
import style0 from "./order-history.vue?vue&type=style&index=0&id=3cb5ed11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb5ed11",
  null
  
)

export default component.exports